// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/kycb/acceptance/persons/firstparty/v1/get_person_acceptance.proto

/* oxlint-disable */
import { ApiTimestamp } from "../../../../../../google/protobuf/timestamp";

/** Current KYC acceptance status. */
export const ApiKycCurrentStatus = {
  /** KYC_CURRENT_STATUS_UNSPECIFIED - Unspecified status (for forward compatibility). */
  KYC_CURRENT_STATUS_UNSPECIFIED: "KYC_CURRENT_STATUS_UNSPECIFIED",
  /**
   * KYC verification is pending.
   */
  pending: "pending",
  /**
   * KYC verification has been accepted.
   */
  accepted: "accepted",
  /**
   * KYC verification has been refused.
   */
  refused: "refused",
} as const;

export type ApiKycCurrentStatus = typeof ApiKycCurrentStatus[keyof typeof ApiKycCurrentStatus];

export namespace ApiKycCurrentStatus {
  export type KYC_CURRENT_STATUS_UNSPECIFIED = typeof ApiKycCurrentStatus.KYC_CURRENT_STATUS_UNSPECIFIED;
  export type pending = typeof ApiKycCurrentStatus.pending;
  export type accepted = typeof ApiKycCurrentStatus.accepted;
  export type refused = typeof ApiKycCurrentStatus.refused;
}

export function apiKycCurrentStatusFromJSON(object: any): ApiKycCurrentStatus {
  switch (object) {
    case 0:
    case "KYC_CURRENT_STATUS_UNSPECIFIED":
      return ApiKycCurrentStatus.KYC_CURRENT_STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiKycCurrentStatus.pending;
    case 2:
    case "accepted":
      return ApiKycCurrentStatus.accepted;
    case 3:
    case "refused":
      return ApiKycCurrentStatus.refused;
    default:
      return ApiKycCurrentStatus.KYC_CURRENT_STATUS_UNSPECIFIED;
  }
}

export function apiKycCurrentStatusToJSON(object: ApiKycCurrentStatus): string {
  switch (object) {
    case ApiKycCurrentStatus.KYC_CURRENT_STATUS_UNSPECIFIED:
      return "KYC_CURRENT_STATUS_UNSPECIFIED";
    case ApiKycCurrentStatus.pending:
      return "pending";
    case ApiKycCurrentStatus.accepted:
      return "accepted";
    case ApiKycCurrentStatus.refused:
      return "refused";
    default:
      return "KYC_CURRENT_STATUS_UNSPECIFIED";
  }
}

/** Type of KYC process. */
export const ApiProcessType = {
  /** PROCESS_TYPE_UNSPECIFIED - Unspecified type (for forward compatibility). */
  PROCESS_TYPE_UNSPECIFIED: "PROCESS_TYPE_UNSPECIFIED",
  /**
   * Initial KYC verification for new users.
   */
  initial: "initial",
  /**
   * Re-KYC verification for existing users.
   */
  re_kyc: "re_kyc",
  /**
   * Proof of Identity renewal.
   */
  poi_renewal: "poi_renewal",
} as const;

export type ApiProcessType = typeof ApiProcessType[keyof typeof ApiProcessType];

export namespace ApiProcessType {
  export type PROCESS_TYPE_UNSPECIFIED = typeof ApiProcessType.PROCESS_TYPE_UNSPECIFIED;
  export type initial = typeof ApiProcessType.initial;
  export type re_kyc = typeof ApiProcessType.re_kyc;
  export type poi_renewal = typeof ApiProcessType.poi_renewal;
}

export function apiProcessTypeFromJSON(object: any): ApiProcessType {
  switch (object) {
    case 0:
    case "PROCESS_TYPE_UNSPECIFIED":
      return ApiProcessType.PROCESS_TYPE_UNSPECIFIED;
    case 1:
    case "initial":
      return ApiProcessType.initial;
    case 2:
    case "re_kyc":
      return ApiProcessType.re_kyc;
    case 3:
    case "poi_renewal":
      return ApiProcessType.poi_renewal;
    default:
      return ApiProcessType.PROCESS_TYPE_UNSPECIFIED;
  }
}

export function apiProcessTypeToJSON(object: ApiProcessType): string {
  switch (object) {
    case ApiProcessType.PROCESS_TYPE_UNSPECIFIED:
      return "PROCESS_TYPE_UNSPECIFIED";
    case ApiProcessType.initial:
      return "initial";
    case ApiProcessType.re_kyc:
      return "re_kyc";
    case ApiProcessType.poi_renewal:
      return "poi_renewal";
    default:
      return "PROCESS_TYPE_UNSPECIFIED";
  }
}

/** Status of the active KYC process. */
export const ApiProcessStatus = {
  /** PROCESS_STATUS_UNSPECIFIED - Unspecified status (for forward compatibility). */
  PROCESS_STATUS_UNSPECIFIED: "PROCESS_STATUS_UNSPECIFIED",
  /**
   * Personal information is pending submission.
   */
  pending_personal_info: "pending_personal_info",
  /**
   * Liveness verification is pending.
   */
  pending_liveness: "pending_liveness",
  /**
   * User action is required (e.g., additional documents).
   */
  pending_user_action: "pending_user_action",
  /**
   * Process has been submitted.
   */
  submitted: "submitted",
} as const;

export type ApiProcessStatus = typeof ApiProcessStatus[keyof typeof ApiProcessStatus];

export namespace ApiProcessStatus {
  export type PROCESS_STATUS_UNSPECIFIED = typeof ApiProcessStatus.PROCESS_STATUS_UNSPECIFIED;
  export type pending_personal_info = typeof ApiProcessStatus.pending_personal_info;
  export type pending_liveness = typeof ApiProcessStatus.pending_liveness;
  export type pending_user_action = typeof ApiProcessStatus.pending_user_action;
  export type submitted = typeof ApiProcessStatus.submitted;
}

export function apiProcessStatusFromJSON(object: any): ApiProcessStatus {
  switch (object) {
    case 0:
    case "PROCESS_STATUS_UNSPECIFIED":
      return ApiProcessStatus.PROCESS_STATUS_UNSPECIFIED;
    case 1:
    case "pending_personal_info":
      return ApiProcessStatus.pending_personal_info;
    case 2:
    case "pending_liveness":
      return ApiProcessStatus.pending_liveness;
    case 3:
    case "pending_user_action":
      return ApiProcessStatus.pending_user_action;
    case 4:
    case "submitted":
      return ApiProcessStatus.submitted;
    default:
      return ApiProcessStatus.PROCESS_STATUS_UNSPECIFIED;
  }
}

export function apiProcessStatusToJSON(object: ApiProcessStatus): string {
  switch (object) {
    case ApiProcessStatus.PROCESS_STATUS_UNSPECIFIED:
      return "PROCESS_STATUS_UNSPECIFIED";
    case ApiProcessStatus.pending_personal_info:
      return "pending_personal_info";
    case ApiProcessStatus.pending_liveness:
      return "pending_liveness";
    case ApiProcessStatus.pending_user_action:
      return "pending_user_action";
    case ApiProcessStatus.submitted:
      return "submitted";
    default:
      return "PROCESS_STATUS_UNSPECIFIED";
  }
}

/** KYC verification provider. */
export const ApiProvider = {
  /** PROVIDER_UNSPECIFIED - Unspecified provider (for forward compatibility). */
  PROVIDER_UNSPECIFIED: "PROVIDER_UNSPECIFIED",
  /**
   * Fourthline provider.
   */
  fourthline: "fourthline",
  /**
   * IDNow provider.
   */
  idnow: "idnow",
} as const;

export type ApiProvider = typeof ApiProvider[keyof typeof ApiProvider];

export namespace ApiProvider {
  export type PROVIDER_UNSPECIFIED = typeof ApiProvider.PROVIDER_UNSPECIFIED;
  export type fourthline = typeof ApiProvider.fourthline;
  export type idnow = typeof ApiProvider.idnow;
}

export function apiProviderFromJSON(object: any): ApiProvider {
  switch (object) {
    case 0:
    case "PROVIDER_UNSPECIFIED":
      return ApiProvider.PROVIDER_UNSPECIFIED;
    case 1:
    case "fourthline":
      return ApiProvider.fourthline;
    case 2:
    case "idnow":
      return ApiProvider.idnow;
    default:
      return ApiProvider.PROVIDER_UNSPECIFIED;
  }
}

export function apiProviderToJSON(object: ApiProvider): string {
  switch (object) {
    case ApiProvider.PROVIDER_UNSPECIFIED:
      return "PROVIDER_UNSPECIFIED";
    case ApiProvider.fourthline:
      return "fourthline";
    case ApiProvider.idnow:
      return "idnow";
    default:
      return "PROVIDER_UNSPECIFIED";
  }
}

/**
 * Request message for GetPersonAcceptance RPC.
 * Authentication is done via PASETO token.
 */
export interface ApiGetPersonAcceptanceRequest {
  /** The market to filter the acceptance status for (e.g., "FR", "DE", "ES"). */
  readonly market?: string | null | undefined;
}

/** Response message for GetPersonAcceptance RPC. */
export interface ApiGetPersonAcceptanceResponse {
  /** Current KYC acceptance status for the authenticated user. */
  readonly kycCurrentStatus: ApiKycCurrentStatus;
  /** The active KYC process, if any. Null if no active process. */
  readonly activeProcess?: ApiActiveProcess | null | undefined;
}

/** Represents an active KYC process. */
export interface ApiActiveProcess {
  /** The type of KYC process. */
  readonly type: ApiProcessType;
  /** The current status of the process. */
  readonly processStatus: ApiProcessStatus;
  /**
   * Date when the KYC process should be completed.
   * Null if there is no due date assigned to this specific process.
   */
  readonly dueDate?:
    | Date
    | null
    | undefined;
  /**
   * The provider the user should use to complete the KYC process.
   * Null if the provider is not yet determined.
   */
  readonly provider?:
    | ApiProvider
    | null
    | undefined;
  /** Provider-specific details for initializing the SDK/redirections. */
  readonly providerDetails:
    | //
    /** Details for Fourthline provider. */
    { readonly $case: "fourthlineProviderDetails"; readonly value: ApiFourthlineProviderDetails }
    | //
    /** Details for IDNow provider. */
    { readonly $case: "idnowProviderDetails"; readonly value: ApiIdnowProviderDetails }
    | null;
  /** Whether a signature is required for this process. */
  readonly signatureRequired: boolean;
  /**
   * The membership ID linked to this active process.
   * Absent when no membership exists yet (e.g. register-flow user before membership sync).
   */
  readonly membershipId?:
    | string
    | null
    | undefined;
  /**
   * The organization ID linked to this active process via its membership.
   * Absent when no membership exists yet (e.g. register-flow user before membership sync)
   * or when the membership has no organization linked.
   */
  readonly organizationId?:
    | string
    | null
    | undefined;
  /**
   * Stable identifier of the IdentityVerification abstraction in kyc-gateway.
   * Absent for processes started before AP called kyc-gateway upfront (old flow).
   */
  readonly identityVerificationId?: string | null | undefined;
}

/** Provider details for Fourthline. */
export interface ApiFourthlineProviderDetails {
  /** Provider token to initialize the SDK. */
  readonly token: string;
  /** URL to show QR code and send SMS (for web). */
  readonly redirectUrl: string;
}

/** Provider details for IDNow. */
export interface ApiIdnowProviderDetails {
  /** Provider token to initialize the SDK. */
  readonly token: string;
  /** URL with the redo token. */
  readonly verificationUrl: string;
  /** Reason for the IDNow error, if any. */
  readonly reason: ApiIdnowProviderDetailsErrorReason;
  /** Current status from the IDNow provider. */
  readonly status: ApiIdnowProviderDetailsStatus;
}

/** IDNow error reasons. */
export const ApiIdnowProviderDetailsErrorReason = {
  /** ERROR_REASON_UNSPECIFIED - Unspecified reason (for forward compatibility). */
  ERROR_REASON_UNSPECIFIED: "ERROR_REASON_UNSPECIFIED",
  /**
   * Connection issues during verification.
   */
  connection_issues: "connection_issues",
  /**
   * General IDNow service issue.
   */
  idnow_issue: "idnow_issue",
  /**
   * No audio detected during verification.
   */
  no_audio: "no_audio",
  /**
   * No video detected during verification.
   */
  no_video: "no_video",
  /**
   * Wrong language used during verification.
   */
  wrong_language: "wrong_language",
  /**
   * Bad audio quality during verification.
   */
  bad_audio: "bad_audio",
  /**
   * ID document type not supported.
   */
  id_not_supported: "id_not_supported",
  /**
   * Generic error.
   */
  generic: "generic",
  /**
   * Bad video quality during verification.
   */
  bad_video: "bad_video",
  /**
   * ID document is damaged.
   */
  id_damaged: "id_damaged",
  /**
   * Agent aborted the verification.
   */
  agent_abort: "agent_abort",
  /**
   * User aborted the verification.
   */
  user_abort: "user_abort",
  /**
   * No ID document presented.
   */
  no_id: "no_id",
  /**
   * Wrong person presented during verification.
   */
  wrong_person: "wrong_person",
  /**
   * Identification code not received.
   */
  ident_code_not_received: "ident_code_not_received",
  /**
   * IDNow disconnected during verification.
   */
  idnow_disconnected: "idnow_disconnected",
  /**
   * ID document has expired.
   */
  id_expired: "id_expired",
  /**
   * ID hologram issue detected.
   */
  id_hologram: "id_hologram",
  /**
   * Lighting issues during verification.
   */
  lightning: "lightning",
  /**
   * Generic video issue.
   */
  video_generic_issue: "video_generic_issue",
  /**
   * Background noise detected.
   */
  background_noise: "background_noise",
  /**
   * Generic audio issue.
   */
  audio_generic_issue: "audio_generic_issue",
  /**
   * Wrong ID code provided.
   */
  wrong_id_code: "wrong_id_code",
  /**
   * User aborted while waiting.
   */
  user_abort_while_waiting: "user_abort_while_waiting",
  /**
   * Wrong device used for verification.
   */
  other_device: "other_device",
  /**
   * Generic ID issue.
   */
  id_generic_issue: "id_generic_issue",
  /**
   * Timeout due to stalled connection.
   */
  stalled_timeout: "stalled_timeout",
  /**
   * Call quality check failed.
   */
  call_quality_fail: "call_quality_fail",
  /**
   * No consent for video identification.
   */
  no_video_ident_consent: "no_video_ident_consent",
  /**
   * Wrong ID number provided.
   */
  wrong_id_number: "wrong_id_number",
  /**
   * QES (Qualified Electronic Signature) issue.
   */
  qes_issue: "qes_issue",
  /**
   * Wrong phone number provided.
   */
  wrong_phone_number: "wrong_phone_number",
  /**
   * No agents available.
   */
  no_agents: "no_agents",
} as const;

export type ApiIdnowProviderDetailsErrorReason =
  typeof ApiIdnowProviderDetailsErrorReason[keyof typeof ApiIdnowProviderDetailsErrorReason];

export namespace ApiIdnowProviderDetailsErrorReason {
  export type ERROR_REASON_UNSPECIFIED = typeof ApiIdnowProviderDetailsErrorReason.ERROR_REASON_UNSPECIFIED;
  export type connection_issues = typeof ApiIdnowProviderDetailsErrorReason.connection_issues;
  export type idnow_issue = typeof ApiIdnowProviderDetailsErrorReason.idnow_issue;
  export type no_audio = typeof ApiIdnowProviderDetailsErrorReason.no_audio;
  export type no_video = typeof ApiIdnowProviderDetailsErrorReason.no_video;
  export type wrong_language = typeof ApiIdnowProviderDetailsErrorReason.wrong_language;
  export type bad_audio = typeof ApiIdnowProviderDetailsErrorReason.bad_audio;
  export type id_not_supported = typeof ApiIdnowProviderDetailsErrorReason.id_not_supported;
  export type generic = typeof ApiIdnowProviderDetailsErrorReason.generic;
  export type bad_video = typeof ApiIdnowProviderDetailsErrorReason.bad_video;
  export type id_damaged = typeof ApiIdnowProviderDetailsErrorReason.id_damaged;
  export type agent_abort = typeof ApiIdnowProviderDetailsErrorReason.agent_abort;
  export type user_abort = typeof ApiIdnowProviderDetailsErrorReason.user_abort;
  export type no_id = typeof ApiIdnowProviderDetailsErrorReason.no_id;
  export type wrong_person = typeof ApiIdnowProviderDetailsErrorReason.wrong_person;
  export type ident_code_not_received = typeof ApiIdnowProviderDetailsErrorReason.ident_code_not_received;
  export type idnow_disconnected = typeof ApiIdnowProviderDetailsErrorReason.idnow_disconnected;
  export type id_expired = typeof ApiIdnowProviderDetailsErrorReason.id_expired;
  export type id_hologram = typeof ApiIdnowProviderDetailsErrorReason.id_hologram;
  export type lightning = typeof ApiIdnowProviderDetailsErrorReason.lightning;
  export type video_generic_issue = typeof ApiIdnowProviderDetailsErrorReason.video_generic_issue;
  export type background_noise = typeof ApiIdnowProviderDetailsErrorReason.background_noise;
  export type audio_generic_issue = typeof ApiIdnowProviderDetailsErrorReason.audio_generic_issue;
  export type wrong_id_code = typeof ApiIdnowProviderDetailsErrorReason.wrong_id_code;
  export type user_abort_while_waiting = typeof ApiIdnowProviderDetailsErrorReason.user_abort_while_waiting;
  export type other_device = typeof ApiIdnowProviderDetailsErrorReason.other_device;
  export type id_generic_issue = typeof ApiIdnowProviderDetailsErrorReason.id_generic_issue;
  export type stalled_timeout = typeof ApiIdnowProviderDetailsErrorReason.stalled_timeout;
  export type call_quality_fail = typeof ApiIdnowProviderDetailsErrorReason.call_quality_fail;
  export type no_video_ident_consent = typeof ApiIdnowProviderDetailsErrorReason.no_video_ident_consent;
  export type wrong_id_number = typeof ApiIdnowProviderDetailsErrorReason.wrong_id_number;
  export type qes_issue = typeof ApiIdnowProviderDetailsErrorReason.qes_issue;
  export type wrong_phone_number = typeof ApiIdnowProviderDetailsErrorReason.wrong_phone_number;
  export type no_agents = typeof ApiIdnowProviderDetailsErrorReason.no_agents;
}

export function apiIdnowProviderDetailsErrorReasonFromJSON(object: any): ApiIdnowProviderDetailsErrorReason {
  switch (object) {
    case 0:
    case "ERROR_REASON_UNSPECIFIED":
      return ApiIdnowProviderDetailsErrorReason.ERROR_REASON_UNSPECIFIED;
    case 1:
    case "connection_issues":
      return ApiIdnowProviderDetailsErrorReason.connection_issues;
    case 2:
    case "idnow_issue":
      return ApiIdnowProviderDetailsErrorReason.idnow_issue;
    case 3:
    case "no_audio":
      return ApiIdnowProviderDetailsErrorReason.no_audio;
    case 4:
    case "no_video":
      return ApiIdnowProviderDetailsErrorReason.no_video;
    case 5:
    case "wrong_language":
      return ApiIdnowProviderDetailsErrorReason.wrong_language;
    case 6:
    case "bad_audio":
      return ApiIdnowProviderDetailsErrorReason.bad_audio;
    case 7:
    case "id_not_supported":
      return ApiIdnowProviderDetailsErrorReason.id_not_supported;
    case 8:
    case "generic":
      return ApiIdnowProviderDetailsErrorReason.generic;
    case 9:
    case "bad_video":
      return ApiIdnowProviderDetailsErrorReason.bad_video;
    case 10:
    case "id_damaged":
      return ApiIdnowProviderDetailsErrorReason.id_damaged;
    case 11:
    case "agent_abort":
      return ApiIdnowProviderDetailsErrorReason.agent_abort;
    case 12:
    case "user_abort":
      return ApiIdnowProviderDetailsErrorReason.user_abort;
    case 13:
    case "no_id":
      return ApiIdnowProviderDetailsErrorReason.no_id;
    case 14:
    case "wrong_person":
      return ApiIdnowProviderDetailsErrorReason.wrong_person;
    case 15:
    case "ident_code_not_received":
      return ApiIdnowProviderDetailsErrorReason.ident_code_not_received;
    case 16:
    case "idnow_disconnected":
      return ApiIdnowProviderDetailsErrorReason.idnow_disconnected;
    case 17:
    case "id_expired":
      return ApiIdnowProviderDetailsErrorReason.id_expired;
    case 18:
    case "id_hologram":
      return ApiIdnowProviderDetailsErrorReason.id_hologram;
    case 19:
    case "lightning":
      return ApiIdnowProviderDetailsErrorReason.lightning;
    case 20:
    case "video_generic_issue":
      return ApiIdnowProviderDetailsErrorReason.video_generic_issue;
    case 21:
    case "background_noise":
      return ApiIdnowProviderDetailsErrorReason.background_noise;
    case 22:
    case "audio_generic_issue":
      return ApiIdnowProviderDetailsErrorReason.audio_generic_issue;
    case 23:
    case "wrong_id_code":
      return ApiIdnowProviderDetailsErrorReason.wrong_id_code;
    case 24:
    case "user_abort_while_waiting":
      return ApiIdnowProviderDetailsErrorReason.user_abort_while_waiting;
    case 25:
    case "other_device":
      return ApiIdnowProviderDetailsErrorReason.other_device;
    case 26:
    case "id_generic_issue":
      return ApiIdnowProviderDetailsErrorReason.id_generic_issue;
    case 27:
    case "stalled_timeout":
      return ApiIdnowProviderDetailsErrorReason.stalled_timeout;
    case 28:
    case "call_quality_fail":
      return ApiIdnowProviderDetailsErrorReason.call_quality_fail;
    case 29:
    case "no_video_ident_consent":
      return ApiIdnowProviderDetailsErrorReason.no_video_ident_consent;
    case 30:
    case "wrong_id_number":
      return ApiIdnowProviderDetailsErrorReason.wrong_id_number;
    case 31:
    case "qes_issue":
      return ApiIdnowProviderDetailsErrorReason.qes_issue;
    case 32:
    case "wrong_phone_number":
      return ApiIdnowProviderDetailsErrorReason.wrong_phone_number;
    case 33:
    case "no_agents":
      return ApiIdnowProviderDetailsErrorReason.no_agents;
    default:
      return ApiIdnowProviderDetailsErrorReason.ERROR_REASON_UNSPECIFIED;
  }
}

export function apiIdnowProviderDetailsErrorReasonToJSON(object: ApiIdnowProviderDetailsErrorReason): string {
  switch (object) {
    case ApiIdnowProviderDetailsErrorReason.ERROR_REASON_UNSPECIFIED:
      return "ERROR_REASON_UNSPECIFIED";
    case ApiIdnowProviderDetailsErrorReason.connection_issues:
      return "connection_issues";
    case ApiIdnowProviderDetailsErrorReason.idnow_issue:
      return "idnow_issue";
    case ApiIdnowProviderDetailsErrorReason.no_audio:
      return "no_audio";
    case ApiIdnowProviderDetailsErrorReason.no_video:
      return "no_video";
    case ApiIdnowProviderDetailsErrorReason.wrong_language:
      return "wrong_language";
    case ApiIdnowProviderDetailsErrorReason.bad_audio:
      return "bad_audio";
    case ApiIdnowProviderDetailsErrorReason.id_not_supported:
      return "id_not_supported";
    case ApiIdnowProviderDetailsErrorReason.generic:
      return "generic";
    case ApiIdnowProviderDetailsErrorReason.bad_video:
      return "bad_video";
    case ApiIdnowProviderDetailsErrorReason.id_damaged:
      return "id_damaged";
    case ApiIdnowProviderDetailsErrorReason.agent_abort:
      return "agent_abort";
    case ApiIdnowProviderDetailsErrorReason.user_abort:
      return "user_abort";
    case ApiIdnowProviderDetailsErrorReason.no_id:
      return "no_id";
    case ApiIdnowProviderDetailsErrorReason.wrong_person:
      return "wrong_person";
    case ApiIdnowProviderDetailsErrorReason.ident_code_not_received:
      return "ident_code_not_received";
    case ApiIdnowProviderDetailsErrorReason.idnow_disconnected:
      return "idnow_disconnected";
    case ApiIdnowProviderDetailsErrorReason.id_expired:
      return "id_expired";
    case ApiIdnowProviderDetailsErrorReason.id_hologram:
      return "id_hologram";
    case ApiIdnowProviderDetailsErrorReason.lightning:
      return "lightning";
    case ApiIdnowProviderDetailsErrorReason.video_generic_issue:
      return "video_generic_issue";
    case ApiIdnowProviderDetailsErrorReason.background_noise:
      return "background_noise";
    case ApiIdnowProviderDetailsErrorReason.audio_generic_issue:
      return "audio_generic_issue";
    case ApiIdnowProviderDetailsErrorReason.wrong_id_code:
      return "wrong_id_code";
    case ApiIdnowProviderDetailsErrorReason.user_abort_while_waiting:
      return "user_abort_while_waiting";
    case ApiIdnowProviderDetailsErrorReason.other_device:
      return "other_device";
    case ApiIdnowProviderDetailsErrorReason.id_generic_issue:
      return "id_generic_issue";
    case ApiIdnowProviderDetailsErrorReason.stalled_timeout:
      return "stalled_timeout";
    case ApiIdnowProviderDetailsErrorReason.call_quality_fail:
      return "call_quality_fail";
    case ApiIdnowProviderDetailsErrorReason.no_video_ident_consent:
      return "no_video_ident_consent";
    case ApiIdnowProviderDetailsErrorReason.wrong_id_number:
      return "wrong_id_number";
    case ApiIdnowProviderDetailsErrorReason.qes_issue:
      return "qes_issue";
    case ApiIdnowProviderDetailsErrorReason.wrong_phone_number:
      return "wrong_phone_number";
    case ApiIdnowProviderDetailsErrorReason.no_agents:
      return "no_agents";
    default:
      return "ERROR_REASON_UNSPECIFIED";
  }
}

/** IDNow provider status. */
export const ApiIdnowProviderDetailsStatus = {
  /** STATUS_UNSPECIFIED - Unspecified status (for forward compatibility). */
  STATUS_UNSPECIFIED: "STATUS_UNSPECIFIED",
  /**
   * Verification is pending.
   */
  pending: "pending",
  /**
   * User is on a call with an agent.
   */
  on_call: "on_call",
  /**
   * Waiting for verification results.
   */
  waiting_results: "waiting_results",
  /**
   * Verification succeeded.
   */
  succeeded: "succeeded",
  /**
   * Verification was canceled.
   */
  canceled: "canceled",
  /**
   * Verification was rejected.
   */
  rejected: "rejected",
  /**
   * Verification failed.
   */
  failed: "failed",
} as const;

export type ApiIdnowProviderDetailsStatus =
  typeof ApiIdnowProviderDetailsStatus[keyof typeof ApiIdnowProviderDetailsStatus];

export namespace ApiIdnowProviderDetailsStatus {
  export type STATUS_UNSPECIFIED = typeof ApiIdnowProviderDetailsStatus.STATUS_UNSPECIFIED;
  export type pending = typeof ApiIdnowProviderDetailsStatus.pending;
  export type on_call = typeof ApiIdnowProviderDetailsStatus.on_call;
  export type waiting_results = typeof ApiIdnowProviderDetailsStatus.waiting_results;
  export type succeeded = typeof ApiIdnowProviderDetailsStatus.succeeded;
  export type canceled = typeof ApiIdnowProviderDetailsStatus.canceled;
  export type rejected = typeof ApiIdnowProviderDetailsStatus.rejected;
  export type failed = typeof ApiIdnowProviderDetailsStatus.failed;
}

export function apiIdnowProviderDetailsStatusFromJSON(object: any): ApiIdnowProviderDetailsStatus {
  switch (object) {
    case 0:
    case "STATUS_UNSPECIFIED":
      return ApiIdnowProviderDetailsStatus.STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiIdnowProviderDetailsStatus.pending;
    case 2:
    case "on_call":
      return ApiIdnowProviderDetailsStatus.on_call;
    case 3:
    case "waiting_results":
      return ApiIdnowProviderDetailsStatus.waiting_results;
    case 4:
    case "succeeded":
      return ApiIdnowProviderDetailsStatus.succeeded;
    case 5:
    case "canceled":
      return ApiIdnowProviderDetailsStatus.canceled;
    case 6:
    case "rejected":
      return ApiIdnowProviderDetailsStatus.rejected;
    case 7:
    case "failed":
      return ApiIdnowProviderDetailsStatus.failed;
    default:
      return ApiIdnowProviderDetailsStatus.STATUS_UNSPECIFIED;
  }
}

export function apiIdnowProviderDetailsStatusToJSON(object: ApiIdnowProviderDetailsStatus): string {
  switch (object) {
    case ApiIdnowProviderDetailsStatus.STATUS_UNSPECIFIED:
      return "STATUS_UNSPECIFIED";
    case ApiIdnowProviderDetailsStatus.pending:
      return "pending";
    case ApiIdnowProviderDetailsStatus.on_call:
      return "on_call";
    case ApiIdnowProviderDetailsStatus.waiting_results:
      return "waiting_results";
    case ApiIdnowProviderDetailsStatus.succeeded:
      return "succeeded";
    case ApiIdnowProviderDetailsStatus.canceled:
      return "canceled";
    case ApiIdnowProviderDetailsStatus.rejected:
      return "rejected";
    case ApiIdnowProviderDetailsStatus.failed:
      return "failed";
    default:
      return "STATUS_UNSPECIFIED";
  }
}

export const ApiGetPersonAcceptanceRequest: MessageFns<ApiGetPersonAcceptanceRequest> = {
  fromJSON(object: any): ApiGetPersonAcceptanceRequest {
    return { market: isSet(object.market) ? globalThis.String(object.market) : null };
  },

  toJSON(message: ApiGetPersonAcceptanceRequest): unknown {
    const obj: any = {};
    if (message.market !== undefined && message.market !== null) {
      obj.market = message.market;
    }
    return obj;
  },
};

export const ApiGetPersonAcceptanceResponse: MessageFns<ApiGetPersonAcceptanceResponse> = {
  fromJSON(object: any): ApiGetPersonAcceptanceResponse {
    return {
      kycCurrentStatus: isSet(object.kycCurrentStatus)
        ? apiKycCurrentStatusFromJSON(object.kycCurrentStatus)
        : isSet(object.kyc_current_status)
        ? apiKycCurrentStatusFromJSON(object.kyc_current_status)
        : ApiKycCurrentStatus.KYC_CURRENT_STATUS_UNSPECIFIED,
      activeProcess: isSet(object.activeProcess)
        ? ApiActiveProcess.fromJSON(object.activeProcess)
        : isSet(object.active_process)
        ? ApiActiveProcess.fromJSON(object.active_process)
        : null,
    };
  },

  toJSON(message: ApiGetPersonAcceptanceResponse): unknown {
    const obj: any = {};
    if (message.kycCurrentStatus !== undefined && message.kycCurrentStatus !== null) {
      obj.kycCurrentStatus = apiKycCurrentStatusToJSON(message.kycCurrentStatus);
    }
    if (message.activeProcess !== undefined && message.activeProcess !== null) {
      obj.activeProcess = ApiActiveProcess.toJSON(message.activeProcess);
    }
    return obj;
  },
};

export const ApiActiveProcess: MessageFns<ApiActiveProcess> = {
  fromJSON(object: any): ApiActiveProcess {
    return {
      type: isSet(object.type) ? apiProcessTypeFromJSON(object.type) : ApiProcessType.PROCESS_TYPE_UNSPECIFIED,
      processStatus: isSet(object.processStatus)
        ? apiProcessStatusFromJSON(object.processStatus)
        : isSet(object.process_status)
        ? apiProcessStatusFromJSON(object.process_status)
        : ApiProcessStatus.PROCESS_STATUS_UNSPECIFIED,
      dueDate: isSet(object.dueDate)
        ? fromJsonTimestamp(object.dueDate)
        : isSet(object.due_date)
        ? fromJsonTimestamp(object.due_date)
        : null,
      provider: isSet(object.provider) ? apiProviderFromJSON(object.provider) : null,
      providerDetails: isSet(object.fourthlineProviderDetails)
        ? {
          $case: "fourthlineProviderDetails",
          value: ApiFourthlineProviderDetails.fromJSON(object.fourthlineProviderDetails),
        }
        : isSet(object.fourthline_provider_details)
        ? {
          $case: "fourthlineProviderDetails",
          value: ApiFourthlineProviderDetails.fromJSON(object.fourthline_provider_details),
        }
        : isSet(object.idnowProviderDetails)
        ? { $case: "idnowProviderDetails", value: ApiIdnowProviderDetails.fromJSON(object.idnowProviderDetails) }
        : isSet(object.idnow_provider_details)
        ? { $case: "idnowProviderDetails", value: ApiIdnowProviderDetails.fromJSON(object.idnow_provider_details) }
        : null,
      signatureRequired: isSet(object.signatureRequired)
        ? globalThis.Boolean(object.signatureRequired)
        : isSet(object.signature_required)
        ? globalThis.Boolean(object.signature_required)
        : false,
      membershipId: isSet(object.membershipId)
        ? globalThis.String(object.membershipId)
        : isSet(object.membership_id)
        ? globalThis.String(object.membership_id)
        : null,
      organizationId: isSet(object.organizationId)
        ? globalThis.String(object.organizationId)
        : isSet(object.organization_id)
        ? globalThis.String(object.organization_id)
        : null,
      identityVerificationId: isSet(object.identityVerificationId)
        ? globalThis.String(object.identityVerificationId)
        : isSet(object.identity_verification_id)
        ? globalThis.String(object.identity_verification_id)
        : null,
    };
  },

  toJSON(message: ApiActiveProcess): unknown {
    const obj: any = {};
    if (message.type !== undefined && message.type !== null) {
      obj.type = apiProcessTypeToJSON(message.type);
    }
    if (message.processStatus !== undefined && message.processStatus !== null) {
      obj.processStatus = apiProcessStatusToJSON(message.processStatus);
    }
    if (message.dueDate !== undefined && message.dueDate !== null) {
      obj.dueDate = message.dueDate.toISOString();
    }
    if (message.provider !== undefined && message.provider !== null) {
      obj.provider = apiProviderToJSON(message.provider);
    }
    if (message.providerDetails?.$case === "fourthlineProviderDetails") {
      obj.fourthlineProviderDetails = ApiFourthlineProviderDetails.toJSON(message.providerDetails.value);
    } else if (message.providerDetails?.$case === "idnowProviderDetails") {
      obj.idnowProviderDetails = ApiIdnowProviderDetails.toJSON(message.providerDetails.value);
    }
    if (message.signatureRequired !== undefined && message.signatureRequired !== null) {
      obj.signatureRequired = message.signatureRequired;
    }
    if (message.membershipId !== undefined && message.membershipId !== null) {
      obj.membershipId = message.membershipId;
    }
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organizationId = message.organizationId;
    }
    if (message.identityVerificationId !== undefined && message.identityVerificationId !== null) {
      obj.identityVerificationId = message.identityVerificationId;
    }
    return obj;
  },
};

export const ApiFourthlineProviderDetails: MessageFns<ApiFourthlineProviderDetails> = {
  fromJSON(object: any): ApiFourthlineProviderDetails {
    return {
      token: isSet(object.token) ? globalThis.String(object.token) : "",
      redirectUrl: isSet(object.redirectUrl)
        ? globalThis.String(object.redirectUrl)
        : isSet(object.redirect_url)
        ? globalThis.String(object.redirect_url)
        : "",
    };
  },

  toJSON(message: ApiFourthlineProviderDetails): unknown {
    const obj: any = {};
    if (message.token !== undefined && message.token !== null) {
      obj.token = message.token;
    }
    if (message.redirectUrl !== undefined && message.redirectUrl !== null) {
      obj.redirectUrl = message.redirectUrl;
    }
    return obj;
  },
};

export const ApiIdnowProviderDetails: MessageFns<ApiIdnowProviderDetails> = {
  fromJSON(object: any): ApiIdnowProviderDetails {
    return {
      token: isSet(object.token) ? globalThis.String(object.token) : "",
      verificationUrl: isSet(object.verificationUrl)
        ? globalThis.String(object.verificationUrl)
        : isSet(object.verification_url)
        ? globalThis.String(object.verification_url)
        : "",
      reason: isSet(object.reason)
        ? apiIdnowProviderDetailsErrorReasonFromJSON(object.reason)
        : ApiIdnowProviderDetailsErrorReason.ERROR_REASON_UNSPECIFIED,
      status: isSet(object.status)
        ? apiIdnowProviderDetailsStatusFromJSON(object.status)
        : ApiIdnowProviderDetailsStatus.STATUS_UNSPECIFIED,
    };
  },

  toJSON(message: ApiIdnowProviderDetails): unknown {
    const obj: any = {};
    if (message.token !== undefined && message.token !== null) {
      obj.token = message.token;
    }
    if (message.verificationUrl !== undefined && message.verificationUrl !== null) {
      obj.verificationUrl = message.verificationUrl;
    }
    if (message.reason !== undefined && message.reason !== null) {
      obj.reason = apiIdnowProviderDetailsErrorReasonToJSON(message.reason);
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiIdnowProviderDetailsStatusToJSON(message.status);
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
